import { render, staticRenderFns } from "./FileExport.vue?vue&type=template&id=52b89c10&"
import script from "./FileExport.vue?vue&type=script&lang=js&"
export * from "./FileExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports